<template>
    <div class="month-picker-container mt-5">
      <!-- Month Picker at Top -->
          <div class="month-picker__header-title">  
            Select Bill Issue Date:
          </div>
      
      <!-- Date Picker Below -->
      <div class="date-picker-section">
        <v-date-picker 
            ref="startSelector"
            :select-attribute="{'aria-label': 'Bill Issue Date'}"
            :drag-attribute="attribute"
            :class="[{show: showDatepicker}, 'no-border']"
            :value="selectedStartDate"
            @dayclick="(...args) => handleDayClick('start',...args)"
            is-required
        />
      </div>
    </div>
  </template>
  
  <script>
  import { DateTime } from 'luxon'
  import DateRangePicker from "@/views/pages/companies/components/DateRangePicker.vue";
  
  export default {
    name: 'BillDatePicker',
    components: {
      DateRangePicker
    },
    props: {
      modelValue: {
        type: Object,
        default: () => ({
          date: DateTime.now().startOf('month'),
          formatted: DateTime.now().toFormat('MMMM yyyy')
        })
      }
    },
    data() {
      return {
        months: [
          'January', 'February', 'March', 'April',
          'May', 'June', 'July', 'August',
          'September', 'October', 'November', 'December'
        ],
        currentDate: DateTime.now().startOf('month'),
        selectedStartDate: DateTime.now().startOf('month'),
        selectedEndDate: DateTime.now().endOf('month'),
        isCustomDateRange: false
      }
    },
    methods: {
      emitChange() {
        this.$emit('update:modelValue', this.currentDate.toFormat('yyyy-MM-dd'))
      },
      handleDayClick(dateType, dateData) {
        const selectedDate = DateTime.fromJSDate(dateData.date)
        this.$emit('update:modelValue', selectedDate.toFormat('yyyy-MM-dd'))
      }
    },
    created() {
      if (this.modelValue?.date) {
        this.currentDate = DateTime.isDateTime(this.modelValue.date) 
          ? this.modelValue.date 
          : DateTime.fromISO(this.modelValue.date)
      }
      this.emitChange()
    }
  }
  </script>
  
  <style scoped lang="scss">
  @import './monthPicker.scss';
  </style>